const ancestor = "问答";
const QuestionRouter = [
  /* 问答首页 */
  {
    path: "/question",
    name: "question",
    meta: { screen: false, title: "问答",keepAlive:true, ancestor },
    component: () => import("@/views/question/Index.vue"),
  },
  {
    path: "/question/create",
    name: "question-create",
    meta: { screen: false, title: "创建问答", ancestor },
    component: () => import("@/views/question/createQuestion/Index.vue"),
  },
  {
    path: "/question/edit/:id",
    name: "question-edit",
    meta: { screen: false, title: "编辑问答", ancestor },
    component: () => import("@/views/question/createQuestion/Index.vue"),
  },
  {
    path: "/question/detail/:id",
    name: "question-detail",
    meta: { screen: false, title: "问答详情", ancestor },
    component: () => import("@/views/question/detail/Index.vue"),
  },
];
export default QuestionRouter;
